<template>
  <div>
    <ArtistTracks />
  </div>
</template>

<script>
import ArtistTracks from '@/modules/artist/tracks/views/Index'

export default {
  components: {
    ArtistTracks
  }
}
</script>
